var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 167,
    viewBox: "0 0 150 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.911 128.266L133.915 128.264C144.09 120.632 149.146 109.068 149.146 93.6669C149.146 83.275 145.721 74.1401 138.879 66.2834C132.221 58.5164 123.232 53.8146 111.952 52.161L143.173 21.3073L143.322 21.1605V20.9516V1.78638V1.28638H142.822H44.5526H44.0526V1.78638V36.9227V37.4227H44.5526H86.7492L59.7943 64.3775L59.4897 64.6821L59.7459 65.0284L73.0864 83.0663L73.3436 83.4141L73.7248 83.2096C78.7871 80.4932 84.2174 79.1353 90.0231 79.1353C94.3228 79.1353 98.0456 80.1783 101.211 82.248L101.211 82.2482L101.223 82.2553C104.318 84.16 105.87 87.0594 105.87 91.0364C105.87 94.9233 104.601 97.9751 102.09 100.247C99.7101 102.389 96.1549 103.501 91.3384 103.501C86.7719 103.501 83.1911 102.514 80.5467 100.59C77.9247 98.6835 76.6189 96.0804 76.6189 92.7274V92.5395V92.0395H76.1189H37.4126H36.9126V92.5395V94.7943C36.9126 108.71 41.9182 119.695 51.9445 127.691L51.95 127.695C62.0863 135.551 75.9236 139.45 93.4052 139.45C110.261 139.45 123.779 135.739 133.911 128.266Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8196_8444",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 1,
    width: 112,
    height: 138
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.879 52.518C122.529 54.0211 131.736 58.7185 138.5 66.6101C145.264 74.3764 148.646 83.3953 148.646 93.6669C148.646 108.949 143.636 120.348 133.615 127.864C123.594 135.254 110.19 138.95 93.4052 138.95C75.9936 138.95 62.2773 135.066 52.2563 127.3C42.3605 119.408 37.4126 108.573 37.4126 94.7943V92.5395H76.1189V92.7274C76.1189 96.2348 77.4968 98.9906 80.2526 100.995C83.0084 102.999 86.7036 104.001 91.3384 104.001C96.2236 104.001 99.9189 102.874 102.424 100.619C105.055 98.239 106.37 95.0448 106.37 91.0364C106.37 86.9027 104.742 83.8337 101.485 81.8295C98.2278 79.7 94.4073 78.6353 90.0231 78.6353C84.1357 78.6353 78.6242 80.0132 73.4884 82.769L60.1479 64.7311L87.9563 36.9227H44.5526V1.78638H142.822V20.9516L110.879 52.518Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8196_8444)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8196_8444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5011 10.4522C35.8117 4.19321 47.3812 8.17625 53.6401 8.5556C62.3646 9.18779 81.5206 11.4764 88.3485 15.5731C96.8833 20.6941 99.9179 39.6604 101.246 50.4712C102.573 61.282 93.659 88.0246 85.5035 92.5765C77.348 97.1284 59.7093 87.4556 52.3124 77.7827C44.9155 68.1099 56.8643 60.3337 57.4333 58.0577C58.0023 55.7818 58.3816 43.6433 53.6401 39.6604C48.8986 35.6775 33.1565 30.3669 26.5182 24.108C19.88 17.8491 25.1906 16.7111 30.5011 10.4522Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.173 48.1998L143.375 21.0376",
    stroke: "url(#paint0_linear_8196_8444)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3379 91.5906L59.1454 64.7241",
    stroke: "url(#paint1_linear_8196_8444)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4126 110.644L73.2201 83.7776",
    stroke: "url(#paint2_linear_8196_8444)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23682 28.1174L44.0443 1.25098",
    stroke: "url(#paint3_linear_8196_8444)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7295 64.7248L85.537 37.8584",
    stroke: "url(#paint4_linear_8196_8444)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24707 64.165L44.0546 37.2986",
    stroke: "url(#paint5_linear_8196_8444)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.173 28.2864L142.98 1.41992",
    stroke: "url(#paint6_linear_8196_8444)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.682 152.941L136.489 126.075",
    stroke: "url(#paint7_linear_8196_8444)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.311 104.05L146.118 77.1836",
    stroke: "url(#paint8_linear_8196_8444)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6377 78.7431L112.445 51.8767",
    stroke: "url(#paint9_linear_8196_8444)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2329 119.451L76.0404 92.5845",
    stroke: "url(#paint10_linear_8196_8444)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1 118.858L36.8075 91.9919",
    stroke: "url(#paint11_linear_8196_8444)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8196_8444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.0899 79.3607C86.7393 80.8639 95.9462 85.5613 102.71 93.4528C109.475 101.219 112.857 110.238 112.857 120.51C112.857 135.792 107.846 147.191 97.8251 154.706C87.8041 162.097 74.4009 165.792 57.6157 165.792C40.2041 165.792 26.4878 161.909 16.4667 154.143C6.57094 146.251 1.62305 135.416 1.62305 121.637V119.382H40.3294V119.57C40.3294 123.078 41.7072 125.833 44.463 127.838C47.2188 129.842 50.9141 130.844 55.5488 130.844C60.4341 130.844 64.1294 129.716 66.6346 127.462C69.2651 125.082 70.5804 121.888 70.5804 117.879C70.5804 113.745 68.952 110.676 65.6951 108.672C62.4383 106.543 58.6178 105.478 54.2336 105.478C48.3462 105.478 42.8346 106.856 37.6988 109.612L24.3583 91.5739L52.1667 63.7655H8.76304V28.6292H107.032V47.7944L75.0899 79.3607Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1219 155.109L98.1251 155.106C108.3 147.475 113.357 135.91 113.357 120.51C113.357 110.118 109.931 100.983 103.089 93.1262C96.431 85.3592 87.4428 80.6574 76.1624 79.0038L107.383 48.1501L107.532 48.0033V47.7944V28.6292V28.1292H107.032H8.76304H8.26304V28.6292V63.7655V64.2655H8.76304H50.9596L24.0048 91.2203L23.7002 91.5249L23.9563 91.8712L37.2968 109.909L37.5541 110.257L37.9352 110.052C42.9976 107.336 48.4278 105.978 54.2336 105.978C58.5333 105.978 62.256 107.021 65.4215 109.091L65.4214 109.091L65.4331 109.098C68.5282 111.003 70.0804 113.902 70.0804 117.879C70.0804 121.766 68.811 124.818 66.3001 127.09C63.9205 129.232 60.3653 130.344 55.5488 130.344C50.9824 130.344 47.4015 129.356 44.7571 127.433C42.1351 125.526 40.8294 122.923 40.8294 119.57V119.382V118.882H40.3294H1.62305H1.12305V119.382V121.637C1.12305 135.553 6.12866 146.538 16.155 154.534L16.1604 154.538C26.2967 162.394 40.1341 166.292 57.6157 166.292C74.471 166.292 87.9894 162.582 98.1219 155.109Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8196_8444",
    x: -51.1277,
    y: -67.5896,
    width: 227.054,
    height: 235.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.274,
    result: "effect1_foregroundBlur_8196_8444"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8196_8444",
    x: -4.74537,
    y: 22.2607,
    width: 123.971,
    height: 149.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8196_8444"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8196_8444",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8196_8444",
    x1: 108.381,
    y1: 48.1997,
    x2: 143.375,
    y2: 21.0376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8196_8444",
    x1: 24.5331,
    y1: 91.5905,
    x2: 59.1454,
    y2: 64.7241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8196_8444",
    x1: 38.6078,
    y1: 110.644,
    x2: 73.2201,
    y2: 83.7776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8196_8444",
    x1: 9.43199,
    y1: 28.1173,
    x2: 44.0443,
    y2: 1.25098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8196_8444",
    x1: 50.9247,
    y1: 64.7247,
    x2: 85.537,
    y2: 37.8584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8196_8444",
    x1: 9.44224,
    y1: 64.1649,
    x2: 44.0546,
    y2: 37.2986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8196_8444",
    x1: 108.368,
    y1: 28.2863,
    x2: 142.98,
    y2: 1.41992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8196_8444",
    x1: 101.877,
    y1: 152.941,
    x2: 136.489,
    y2: 126.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8196_8444",
    x1: 111.506,
    y1: 104.05,
    x2: 146.118,
    y2: 77.1836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8196_8444",
    x1: 77.8329,
    y1: 78.7431,
    x2: 112.445,
    y2: 51.8767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8196_8444",
    x1: 41.4281,
    y1: 119.451,
    x2: 76.0404,
    y2: 92.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8196_8444",
    x1: 2.19517,
    y1: 118.858,
    x2: 36.8075,
    y2: 91.9919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Full);
export default __webpack_public_path__ + "static/media/3__full.c2baef3e795571c48991ddffcddeb77f.svg";
export { ForwardRef as ReactComponent };